module.exports = __webpack_public_path__ + "static/media/kitchenPrep.3c25c9ca.png";